
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20 3.333c3.533 0 6.924 1.391 9.424 3.867a13.168 13.168 0 013.91 9.353c0 4.737-3.852 11.048-11.73 19.419a2.18 2.18 0 01-.73.512 2.2 2.2 0 01-2.48-.51C10.518 27.604 6.667 21.29 6.667 16.553c0-3.509 1.407-6.874 3.909-9.353A13.394 13.394 0 0120 3.333zm0 2a11.398 11.398 0 00-8.017 3.288 11.167 11.167 0 00-3.316 7.932c0 4.047 3.593 9.984 11.195 18.063l.035.026a.254.254 0 00.1.025.247.247 0 00.1-.026.187.187 0 00.05-.04c7.593-8.067 11.186-14 11.186-18.048 0-2.974-1.193-5.829-3.316-7.932A11.398 11.398 0 0020 5.333zm-.002 6.272c1.317 0 2.583.52 3.517 1.445a4.932 4.932 0 01.627 6.26 4.973 4.973 0 01-2.238 1.82 5.001 5.001 0 01-5.423-1.065 4.922 4.922 0 01-1.088-5.404 4.97 4.97 0 013.634-2.959l.162-.029.809-.068zm.055 2.002l-.605.05-.034.007a3.031 3.031 0 00-.824.292l-.25.148a2.932 2.932 0 00-1.271 3.028c.116.573.4 1.098.82 1.512a3.012 3.012 0 003.256.637 2.94 2.94 0 001.837-2.724 2.936 2.936 0 00-.875-2.087 2.997 2.997 0 00-1.815-.85l-.239-.013z","fill":"#0072C8","fill-rule":"evenodd"}})])
          )
        }
      }
    